import {Component} from '@angular/core';

@Component({
  selector: 'app-agreement',
  templateUrl: './agreement-page.component.html',
  styleUrls: ['./agreement-page.component.scss']
})
export class AgreementPageComponent {

}
